import errorLogger from './errorLogger';

/**
 * Configuration des gestionnaires d'erreurs globaux
 * À importer dans index.js pour capturer les erreurs non gérées
 */

// Gestionnaire pour les erreurs JavaScript non capturées
window.addEventListener('error', (event) => {
  errorLogger.log(event.error || event.message, {
    type: 'global',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    globalError: true
  });
});

// Gestionnaire pour les rejets de promesses non gérés
window.addEventListener('unhandledrejection', (event) => {
  errorLogger.log(event.reason, {
    type: 'unhandled_promise',
    globalRejection: true
  });
});

// Gestionnaire pour les erreurs de chunk loading (Code Splitting)
window.addEventListener('error', (event) => {
  if (event.error && event.error.name === 'ChunkLoadError') {
    errorLogger.log(event.error, {
      type: 'chunk_load',
      chunkError: true
    });

    // Optionnel: recharger la page automatiquement pour les erreurs de chunk
    if (window.confirm('Une nouvelle version est disponible. Actualiser la page ?')) {
      window.location.reload();
    }
  }
});

// Intercepter les erreurs de console.error pour les logger aussi
const originalConsoleError = console.error;
console.error = (...args) => {
  // Logger l'erreur
  if (args.length > 0) {
    const error = args[0] instanceof Error ? args[0] : new Error(args.join(' '));
    errorLogger.log(error, {
      type: 'console_error',
      originalArgs: args
    });
  }

  // Appeler l'original
  originalConsoleError.apply(console, args);
};

// Fonction pour envoyer les erreurs accumulées à un service externe
export const sendErrorsToService = () => {
  const errors = errorLogger.exportErrors();

  if (errors.length === 0) return;

  // Ici on pourrait envoyer à un service comme Sentry
  // Exemple:
  // errors.forEach(errorEntry => {
  //   if (window.Sentry) {
  //     window.Sentry.captureException(errorEntry.error, {
  //       contexts: { custom: errorEntry.context }
  //     });
  //   }
  // });

  // Errors prepared for sending to external service
};

// Envoyer les erreurs toutes les 30 secondes (en production seulement)
if (process.env.NODE_ENV === 'production') {
  setInterval(sendErrorsToService, 30000);
}

// Exporter pour utilisation manuelle
export { errorLogger };

const globalErrorHandler = {
  sendErrorsToService,
  errorLogger
};

export default globalErrorHandler;